import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "800px",
    backgroundColor: theme.palette.primary.main,
    padding: "24px",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    justifyContent: "space-between",
  },
  btnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "32px",
  },
  spaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  heading: {
    fontSize: "24px !important",
  },
  submitButton: {
    width: "max-content",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    padding: "12px 50px",
  },
  pointer: {
    height: "35px",
    width: "7px",
    borderBottomLeftRadius: "10px",
    borderBottom: "3px solid #606479",
    borderLeft: "3px solid #606479",
    marginTop: "-10px",
  },
  select: {
    width: "max-content",
    minWidth: "160px",
    height: "42px",
    backgroundColor: theme.palette.primary.main,
    padding: "6px 4px 6px 8px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginTop: "10px",
  },
  input: {
    backgroundColor: theme.palette.primary.main,
  },
  warningTextHeader: {
    textAlign: "center",
    fontWeight: "600",
    fontSize: "22px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  greyText: {
    color: theme.palette.text.tertiary,
    marginRight: "5px",
  },
  listContainer: {
    maxHeight: "400px",
    overflowX: "none",
    overflowY: "auto",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "10px",
  },
  outlinedBtn: {
    width: "max-content",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
    padding: "12px 30px",
  },
  biggerText: {
    fontSize: "16px !important",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  mediumText: {
    fontSize: "14px !important",
  },
  purpleText: {
    color: theme.palette.secondary.main,
    fontSize: "12px !important",
  },
}));

export default useStyles;
